import script from "./ThanksView.vue?vue&type=script&setup=true&lang=js"
export * from "./ThanksView.vue?vue&type=script&setup=true&lang=js"

import "./ThanksView.vue?vue&type=style&index=0&id=0939c212&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0939c212"]])

export default __exports__